import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-option-button',
  templateUrl: './option-button.component.html',
  styleUrls: ['./option-button.component.scss']
})
export class OptionButtonComponent {
  @Input() itemId!: string;
  @Input() isDisabled: boolean = false;

  ngOnInit(): void {
    const userClaim = localStorage.getItem("userClaim");

    if (userClaim) {
      try {
        const parsedClaim = JSON.parse(userClaim);
        this.isDisabled = parsedClaim.IsDisabled?.toLowerCase() === "true";
      } catch (error) {
        console.error("Error parsing userClaim from localStorage", error);
      }
    }
  }

  showOption(id: string, cls: string) {
    if (this.isDisabled) return;

    const activeElement = document.querySelector('.' + cls);
    const targetElement = document.getElementById(id);

    activeElement?.classList.remove(cls);
    if (activeElement?.id !== id) {
      targetElement?.classList.add(cls);
    } else {
      targetElement?.classList.remove(cls);
    }
  }
}